import { API } from "aws-amplify";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { getProjectDetails } from "actions/projects";

export const GET_CUSTOMER_CLASSES_DOWNLOAD_TEMPLATE_REQUEST =
  "@@customerClasses/GET_CUSTOMER_CLASSES_DOWNLOAD_TEMPLATE_REQUEST";
export const GET_CUSTOMER_CLASSES_DOWNLOAD_TEMPLATE_SUCCESS =
  "@@customerClasses/GET_CUSTOMER_CLASSES_DOWNLOAD_TEMPLATE_SUCCESS";
export const GET_CUSTOMER_CLASSES_DOWNLOAD_TEMPLATE_FAILURE =
  "@@customerClasses/GET_CUSTOMER_CLASSES_DOWNLOAD_TEMPLATE_FAILURE";

export function getCustomerClassesDownloadTemplate(
  id = "",
  organisation,
  sample_table = true
) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_CUSTOMER_CLASSES_DOWNLOAD_TEMPLATE_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=scen_customer_classes&organisation=${organisation}&sample_table=${sample_table}`;
      }

      const response = await API.get("usimAPI", url);
      dispatch({
        type: GET_CUSTOMER_CLASSES_DOWNLOAD_TEMPLATE_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_CUSTOMER_CLASSES_DOWNLOAD_TEMPLATE_FAILURE,
        payload: error,
      });
    }
  };
}

export const GET_CUSTOMER_CLASSES_LIST_REQUEST =
  "@@customerClasses/GET_CUSTOMER_CLASSES_LIST_REQUEST";
export const GET_CUSTOMER_CLASSES_LIST_SUCCESS =
  "@@customerClasses/GET_CUSTOMER_CLASSES_LIST_SUCCESS";
export const GET_CUSTOMER_CLASSES_LIST_FAILURE =
  "@@customerClasses/GET_CUSTOMER_CLASSES_LIST_FAILURE";

export function getCustomerClassesList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: GET_CUSTOMER_CLASSES_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=scen_customer_classes&organisation=${organisation}&sample_table=false`;
      }

      const response = await API.get("usimAPI", url);
      dispatch({
        type: GET_CUSTOMER_CLASSES_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_CUSTOMER_CLASSES_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const DELETE_CUSTOMER_CLASSES_LIST_REQUEST =
  "@@customerClasses/DELETE_CUSTOMER_CLASSES_LIST_REQUEST";
export const DELETE_CUSTOMER_CLASSES_LIST_SUCCESS =
  "@@customerClasses/DELETE_CUSTOMER_CLASSES_LIST_SUCCESS";
export const DELETE_CUSTOMER_CLASSES_LIST_FAILURE =
  "@@customerClasses/DELETE_CUSTOMER_CLASSES_LIST_FAILURE";

export function deleteCustomerClassesList(id = "", organisation) {
  return async (dispatch) => {
    if (!(id && organisation)) return;
    dispatch({
      type: DELETE_CUSTOMER_CLASSES_LIST_REQUEST,
    });
    try {
      let url = "/showdata";
      if (id && organisation) {
        url = `${url}?project_id=${id}&table_name=scen_customer_classes&organisation=${organisation}`;
      }

      const response = await API.del("usimAPI", url);
      dispatch({
        type: DELETE_CUSTOMER_CLASSES_LIST_SUCCESS,
        payload: response,
      });
      dispatch(getProjectDetails(id));
    } catch (error) {
      dispatch({
        type: DELETE_CUSTOMER_CLASSES_LIST_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}

export const UPLOAD_CUSTOMER_CLASSES_DATA_REQUEST =
  "@@customerClasses/UPLOAD_CUSTOMER_CLASSES_DATA_REQUEST";
export const UPLOAD_CUSTOMER_CLASSES_DATA_SUCCESS =
  "@@customerClasses/UPLOAD_CUSTOMER_CLASSES_DATA_SUCCESS";
export const UPLOAD_CUSTOMER_CLASSES_DATA_FAILURE =
  "@@customerClasses/UPLOAD_CUSTOMER_CLASSES_DATA_FAILURE";

export function uploadCustomerClassesData(
  id = "",
  organisation,
  file,
  columnMappings,
  callback
) {
  return async (dispatch) => {
    if (!id) return;
    dispatch({
      type: UPLOAD_CUSTOMER_CLASSES_DATA_REQUEST,
    });
    try {
      let url = "/presignedurl";
      if (id) {
        url = `${url}?project_id=${id}&table_name=scen_customer_classes`;
      }

      if (!isEmpty(columnMappings)) {
        url = `${url}&column_mappings=${encodeURI(
          JSON.stringify(columnMappings)
        )}`;
      }

      const response = await API.get("usimAPI", url);

      const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": file.type },
        body: file,
      };
      await fetch(response.uploadURL, requestOptions).then((response) => {
        if (response.status === 200) {
          toast.success("Data uploaded successfully!");

          setTimeout(() => {
            dispatch(getProjectDetails(id));
            dispatch(getCustomerClassesList(id, organisation));
          }, 2000);
          callback({
            success: true,
          });
        } else {
          dispatch({
            type: UPLOAD_CUSTOMER_CLASSES_DATA_FAILURE,
            payload: {
              message: "Upload data failed.",
            },
          });
        }
      });

      dispatch({
        type: UPLOAD_CUSTOMER_CLASSES_DATA_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: UPLOAD_CUSTOMER_CLASSES_DATA_FAILURE,
        payload: error?.response?.data,
      });
    }
  };
}
